import { SplashScreen } from '@/components/SplashScreen';
import { AddReceiptProvider } from '@/providers/AddReceiptContext';
import { ReceiptModalProvider } from '@/providers/ReceiptModalProvider';
import { TransactionDetailProvider } from '@/providers/TransactionDetailProvider';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { protectedBeforeLoad, protectedSearchSchema } from './-_protected.logic';

export const Route = createFileRoute('/_protected')({
  component: ProtectedLayout,
  pendingComponent: SplashScreen,
  validateSearch: protectedSearchSchema,
  beforeLoad: async ({ context, search, location }) => {
    const result = await protectedBeforeLoad({
      auth: context.auth,
      search,
      location,
    });
    if (result && 'redirect' in result) {
      throw redirect({ to: result.redirect });
    }
    if (result && 'pending' in result) {
      // WorkOS redirect is in flight. Hang here so the router stays on
      // pendingComponent (SplashScreen) instead of fetching the route component
      // chunk and racing the navigation.
      await new Promise<never>(() => {});
    }
  },
});

// Providers shared by all authenticated routes (consumer and admin). Consumer-only
// providers (chat session, Tally feedback, bottom nav) live in the `_consumer`
// pathless layout so admin routes never mount them.
function ProtectedLayout() {
  const { auth } = Route.useRouteContext();
  if (auth.isLoading || !auth.workOSUser) {
    return <SplashScreen />;
  }

  return (
    <AddReceiptProvider>
      <ReceiptModalProvider>
        <TransactionDetailProvider>
          <Outlet />
        </TransactionDetailProvider>
      </ReceiptModalProvider>
    </AddReceiptProvider>
  );
}
